import React, { useMemo } from 'react';
import { isEmpty, sortBy, uniqBy } from 'lodash';
import itemIdValue from '../../../itemIdValue';
import Range from '../../../utils/Range';
import useT from '../../utils/Translations/useT';
import MultiselectFilter from './MultiselectFilter';
const RANGE_BEFORE = 1;
const RANGE_AFTER = 2;
const YearsSelector = ({ startingYear = 0, endingYear = 0, years = [], value = [], name = 'years', ...rest }) => {
    const t = useT();
    const options = useMemo(() => {
        const currentYear = new Date().getFullYear();
        if (!isEmpty(years)) {
            return uniqBy(sortBy([...years, currentYear]).map(year => ({
                name: `${year}`,
                value: year,
            })), 'value');
        }
        const min = startingYear && startingYear < endingYear
            ? startingYear
            : currentYear - RANGE_BEFORE;
        const max = endingYear && endingYear > startingYear
            ? endingYear
            : currentYear + RANGE_AFTER;
        return Range(min, max).map(num => ({
            name: `${num}`,
            value: num,
        }));
    }, [years, startingYear, endingYear]);
    return (<MultiselectFilter itemId={itemIdValue} name={name} options={options} title={t('Year')} value={value} {...rest}/>);
};
export default YearsSelector;
